export type OnboardingDriverLicenceState = {
  driverLicenceNumber: string;
  licenceExpiry: string;
  licenceState: string;
  dob: string;
};

export type OnboardingDriverLicenceAction =
  | { type: "SET_DRIVER_LICENCE_NUMBER"; payload: string }
  | { type: "SET_LICENCE_EXPIRY"; payload: string }
  | { type: "SET_LICENCE_STATE"; payload: string }
  | { type: "SET_DOB"; payload: string }
  | { type: "SET_ALL"; payload: Partial<OnboardingDriverLicenceState> };

export const onboardingDriverLicenceInitialState: OnboardingDriverLicenceState = {
  driverLicenceNumber: "",
  licenceExpiry: "",
  licenceState: "",
  dob: "",
};

export function onboardingDriverLicenceReducer(state: OnboardingDriverLicenceState, action: OnboardingDriverLicenceAction): OnboardingDriverLicenceState {
  switch (action.type) {
    case "SET_DRIVER_LICENCE_NUMBER":
      return { ...state, driverLicenceNumber: action.payload };
    case "SET_LICENCE_EXPIRY":
      return { ...state, licenceExpiry: action.payload };
    case "SET_LICENCE_STATE":
      return { ...state, licenceState: action.payload };
    case "SET_DOB":
      return { ...state, dob: action.payload };
    case "SET_ALL":
      return { ...state, ...action.payload };
    default:
      console.log(`Error - incorrect action sent ${JSON.stringify(action)} ${JSON.stringify(state)}`);
      return state;
  }
}
